<template>
  <form v-if="tagsHaveBeenPreloaded">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>{{ $t('Specialist Topics') }}</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="col-md-10 col-lg-8">
            <div class="panel panel-grey">
              <div class="panel-body">

                <tags type="theme" v-model="themeTags"/>
              </div>
            </div>

            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleSaveTagsCallback">
              Save Changes
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tags from 'components/misc/Tags'
import { notify } from 'utils'
import { helpers } from 'mixins/profile'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  components: {
    Tags
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('talent/tag', ['tags']),

    themeTags: {
      get () {
        return this.tags.theme
      },

      set (tags) {
        this.replaceTags({ type: 'theme', tags })
      }
    }
  },

  data () {
    return {
      tagsHaveBeenPreloaded: false
    }
  },

  created () {
    this.loadTags()
  },

  watch: {
    user: 'loadTags'
  },

  methods: {
    ...mapActions('talent/tag', ['getTalentTags', 'updateTalentTags', 'replaceTags']),

    /**
     * Handle saving tags against a user.
     *
     * @return Promise
     */
    handleSaveTagsCallback () {
      return this.updateTalentTags({
        id: this.user.id,
        payload: {
          tags: {
            theme: this.themeTags
          }
        }
      }).then(() => {
        notify.success('Successfully saved talent theme tags.')
        this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.THEMES })
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  }
}
</script>
